import { MappedEntity } from '@api';
import { AssetLogoContainer } from '@terminal/components/asset-logo-container/AssetLogoContainer';
import { FlagIcon } from '@terminal/components/flag-icon/FlagIcon';
import React from 'react';

import { CalendarEvents, isCompanyEvent, isEconomicEvent } from '../utils';
import styles from './CalendarEventDrawerHeader.module.scss';

export const getFallbackEntityTitle = (tag: string) =>
  tag.toUpperCase().replace('_', ':');

export const getEntityLogo = (tag: string, entity?: MappedEntity) => {
  return entity ? (
    <AssetLogoContainer
      className={styles.styledAssetLogoContainer}
      entity={entity}
      size={48}
    />
  ) : (
    <div className={styles.logoFallback} data-testid="logo-fallback">
      {tag.charAt(0)}
    </div>
  );
};

export const getHeaderProps = (data: CalendarEvents) => {
  if (isEconomicEvent(data)) {
    return {
      title: data.name,
      subtitle: data.category,
      titleLogo: (
        <FlagIcon
          data-testid="flag-icon"
          variant="circular"
          countryCode={data.country}
          customSize={48}
        />
      ),
      dateString: data.date,
      reported: data.reported,
    };
  } else if (isCompanyEvent(data)) {
    return {
      title: data.entity?.name ?? getFallbackEntityTitle(data.entity_tag),
      subtitle: data.entity?.formattedTicker ?? '',
      titleLogo: getEntityLogo(data.entity_tag, data.entity),
      dateString: data.effective_date,
      reported: data.reported,
      companyEvent: true,
    };
  } else {
    return {
      title: data.entity?.name ?? getFallbackEntityTitle(data.entity_tag),
      subtitle: data.entity?.formattedTicker ?? '',
      titleLogo: getEntityLogo(data.entity_tag, data.entity),
      dateString: data.reporting_date,
      reported: data.reported,
    };
  }
};
